// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\PierSettings.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// PierSettingsData is the class that PierSettings serializes to/from
export interface PierSettingsData {
	
	
    DefaultDepthUOM : string | null;
    DefaultLengthUOM : string | null;
}

// PierSettingsOptions is the class which may be passed to the PierSettings constructor to define optional initial data values
export interface PierSettingsOptions {
	
	
    DefaultDepthUOM? : string | null;
    DefaultLengthUOM? : string | null;
}

export class PierSettings {
	
	
    public DefaultDepthUOM : DataSignal<string | null>;
    public DefaultLengthUOM : DataSignal<string | null>;

    constructor();
    constructor(data : PierSettingsOptions);
    constructor(data: PierSettingsOptions | null = null) {
	    
	    
        this.DefaultDepthUOM = jsonableObservable(S.value<string | null>(data && data.DefaultDepthUOM !== undefined ? data.DefaultDepthUOM : null));
        this.DefaultLengthUOM = jsonableObservable(S.value<string | null>(data && data.DefaultLengthUOM !== undefined ? data.DefaultLengthUOM : null));
    }

    static key(obj : PierSettings) {
        return ;
    }
    
    static dataKey(obj : PierSettingsOptions) {
        return ;
    }

    static update(obj : PierSettings, data : PierSettingsOptions) {
        S.freeze(() => {
	        
	        
            if (data.DefaultDepthUOM !== undefined) obj.DefaultDepthUOM(data.DefaultDepthUOM);
            if (data.DefaultLengthUOM !== undefined) obj.DefaultLengthUOM(data.DefaultLengthUOM);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PierSettings.ts